import type { SelectedProduct } from '../redux/chat/chatSlice';

/**
 * チャット送信 API（POST /chats/{id}/messages）の product_focus。
 *
 * backend はこの ID（旧形式の商品では名前）を照合キーとしてだけ使い、プロンプトへ入れる
 * 名前・方向性は商品データから引き直す（ChatProductFocus）。画像は当該商品のものだけ採用される。
 */
export interface ChatProductFocusPayload {
  segment_id?: string;
  appeal_id?: string;
  segment_name?: string;
  appeal_name?: string;
  image_id?: number;
}

const toImageId = (id: number | string | undefined): number | undefined => {
  const value = typeof id === 'string' ? Number(id) : id;
  return typeof value === 'number' && Number.isInteger(value) && value > 0 ? value : undefined;
};

/**
 * 送信する商品（productId）と、商品選択モーダルで選んだ内容（Redux の selectedProduct）が
 * 同じ商品のときだけ、選んだ対象・訴求とメイン画像を送信用に組み立てる。何も無ければ undefined（従来どおり送らない）。
 */
export const buildProductFocusPayload = (
  selectedProduct: SelectedProduct | null | undefined,
  productId: number | undefined
): ChatProductFocusPayload | undefined => {
  if (!selectedProduct || productId === undefined || selectedProduct.id !== productId) return undefined;

  const payload: ChatProductFocusPayload = {};
  const intent = selectedProduct.segmentAppeal;
  if (intent?.appealId) {
    payload.segment_id = intent.segmentId || undefined;
    payload.appeal_id = intent.appealId;
    payload.segment_name = intent.segmentName || undefined;
    payload.appeal_name = intent.appealName || undefined;
  }
  const imageId = toImageId(selectedProduct.primaryImage?.id);
  if (imageId !== undefined) payload.image_id = imageId;

  const entries = Object.entries(payload).filter(([, value]) => value !== undefined);
  return entries.length > 0 ? (Object.fromEntries(entries) as ChatProductFocusPayload) : undefined;
};
